import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const VaricoseVeinsPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Varicose Veins</h1>
        <section className="mb-8">
          <p>Varicose veins are enlarged, twisted veins that commonly occur in the legs. Our natural therapies focus on improving blood circulation, strengthening vein walls, and reducing symptoms through herbal remedies and lifestyle changes.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Prolonged standing or sitting</li>
            <li>Obesity</li>
            <li>Pregnancy</li>
            <li>Heredity</li>
            <li>Age-related changes</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Visible twisted veins</li>
            <li>Leg pain and heaviness</li>
            <li>Swelling in legs</li>
            <li>Itching around veins</li>
            <li>Muscle cramps</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use circulation-improving herbs, vein-strengthening remedies, and lifestyle modifications to naturally treat varicose veins. Our approach focuses on improving blood flow and preventing complications through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Improved blood circulation</li>
            <li>Reduced pain and swelling</li>
            <li>No harsh side effects</li>
            <li>Prevents complications</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Regular exercise</li>
            <li>Elevate legs when resting</li>
            <li>Maintain healthy weight</li>
            <li>Avoid prolonged standing</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: How long does it take to see improvement?</strong>
            <p>A: Many patients notice improvement within 2-3 months of consistent treatment.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment safe for pregnant women?</strong>
            <p>A: Yes, our natural remedies are gentle and suitable for pregnant women.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Can this treatment prevent recurrence?</strong>
            <p>A: Yes, our holistic approach helps prevent recurrence by addressing root causes and promoting healthy habits.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from varicose veins—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default VaricoseVeinsPage; 